export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";